export default ((cond, when, otherwise = null)=>cond ? when : otherwise);
